import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import recaptchaKey from '@helpers/misc/recaptchaKey'

export default function Recaptcha(props) {
  return <ReCAPTCHA sitekey={recaptchaKey} onChange={props.onChange} />
}
